import React from "react";

function Footer() {
  return (
    <footer
      className="footer my-5 border-top border-light bg-dark text-light"
      style={{
        alignItems: "center",
        justifyContent: "center",
        height: "fitContent",
        position: "relative",
      }}
    >
      <h6 className="py-3 px-3">CopyRight &copy; | TextUtils</h6>
    </footer>
  );
}

export default Footer;
